module.exports = __webpack_public_path__ + "img/pool-icon-single-stake.2d3641bc.svg";